import { render, staticRenderFns } from "./notfound.vue?vue&type=template&id=4dcd196c&scoped=true&"
var script = {}
import style0 from "./notfound.vue?vue&type=style&index=0&id=4dcd196c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcd196c",
  null
  
)

export default component.exports